import { Routes } from '@angular/router';
import { ROUTES } from './pages/routes';
import { PKeyGuard as PGuard } from './core/guards/p-key.guard';
import { AccessTknGuard as TGuard } from './core/guards/access-tkn.guard';
import { ClientIdGuard as CGuard } from './core/guards/client-id.guard';

export const APP_ROUTES: Routes = [
	{
		path: ROUTES.VERIFY,
		loadComponent: () => import('./pages/verify-identity/verify-identity.component').then((m) => m.VerifyIdentityComponent),
		runGuardsAndResolvers: 'paramsOrQueryParamsChange',
		canActivate: [PGuard],
	},
	{
		path: ROUTES.VERIFIDATA,
		loadComponent: () => import('./pages/verification-data/verification-data.component').then((m) => m.VerificationDataComponent),
		runGuardsAndResolvers: 'paramsOrQueryParamsChange',
		canActivate: [PGuard, TGuard, CGuard],
	},
	{
		path: ROUTES.EMPLOYMENT,
		loadComponent: () => import('./pages/employment-and-address/employment-and-address.component').then((m) => m.EmploymentAndAddressComponent),
		canActivate: [PGuard, TGuard, CGuard],
	},
	{
		path: ROUTES.FINANCIAL,
		loadComponent: () => import('./pages/financial-data/financial-data.component').then((m) => m.FinancialDataComponent),
		canActivate: [PGuard, TGuard, CGuard],
	},
	{
		path: ROUTES.DOCUMENTS,
		loadComponent: () => import('./pages/loading-documents/loading-documents.component').then((m) => m.LoadingDocumentsComponent),
		canActivate: [PGuard, TGuard, CGuard],
	},
	{
		path: ROUTES.FINISHED,
		loadComponent: () => import('./pages/costumer/costumer-finished/costumer-finished.component').then((m) => m.CostumerFinishedComponent),
		canActivate: [PGuard]
	},
	{
		path: '**',
		pathMatch: 'full',
		redirectTo: ROUTES.VERIFY,
	},	
];